<template>
  <el-pagination
    ref="pagination"
    :current-page="value.pageNo"
    :layout="layout"
    :page-size="value.pageSize"
    style="padding-top:30px"
    v-bind="$attrs"
    v-on="$listeners"
    @size-change="sizeChange"
    @current-change="currentChange"
  />
</template>

<script>
export default {
  name: 'base-table-page',
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    val: {
      get: function() {
        return this.value;
      },
      set: function(v) {
        this.$emit('input', v);
      }
    },
    layout() {
      const base = ['total', 'prev', 'pager', 'next', 'jumper'];
      if (this.$attrs['page-sizes']) {
        base.splice(1, 0, 'sizes');
      }
      return base.join(',');
    }
  },
  watch: {
    value: {
      handler: function(v) {
        this.$emit('change', v);
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    currentChange(e) {
      this.val.pageNo = e;
    },
    sizeChange(e) {
      this.val.pageSize = e;
      this.val.pageNo = 1;
    }
  }
};
</script>
